export default (): IAssetState => ({
  loading: false
});
